import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { IconTab } from "@/src/components/iconTab";
import { Avis, Hospitalisation, Patient } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import { getHospitalId, getUserId } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import { openAvisForm } from "../avisForm";
import { RiUser2Line } from "react-icons/ri";
import { ServicesChoice } from "../../hospitalisations/servicesChoice";

function AvisButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Avis) => void;
}) {
  return (
    <IconTab
      id={"avis"}
      activeTabId={null}
      isHorizontal={true}
      name={"Avis"}
      icon={<RiUser2Line size={22} />}
      onChange={async () => {
        let avis: Avis = {
          type: "avis",
          patient,
          creator: getUserId(),
          parent,
          status: "pending",
          service: null,
          doctor: null,
          isDemand: true,
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };
        await openDrawer({
          id: "serviceChoiceDrawer",
          title: "Choisir un service",

          additionalClasses: ["small"],
          content: (
            <ServicesChoice
              // hospitalId={null}
              types={["hospitalisations", "emergencies"]}
              hospitalId={getHospitalId()}
              current={avis.service}
              onChange={async (service) => {
                avis.service = service;

                await openAvisForm({
                  patient,
                  avis,
                  onSave: async (avis) => {
                    closeDrawer("serviceChoiceDrawer");
                    closeDrawer("historyTypeDrawer");
                    onSave(avis);
                  },
                });
              }}
            />
          ),
        });
      }}
    />
  );
}

export default AvisButton;
